import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule, LoadingController, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-language-modal',
  imports: [IonicModule, FormsModule, CommonModule, ReactiveFormsModule],
  templateUrl: './language-modal.html',
  styleUrl: './language-modal.css',
})
export class LanguageModal {




  searchText = '';

  languages = [];

  filteredLanguages = [...this.languages];

  constructor(private modalCtrl: ModalController,
    private loadingCtrl: LoadingController) {}

    async ngOnInit() {
      const loading = await this.loadingCtrl.create({
        message: 'Loading languages...',
        spinner: 'crescent',
        backdropDismiss: false
      });
    
      await loading.present();
    
      try {
        this.languages = await this.getLanguages();
    
        if (!this.languages.length) {
          console.warn('Languages not loaded (mobile issue)');
        }
    
        this.filteredLanguages = [...this.languages];
      } catch (e) {
        console.error(e);
      } finally {
        loading.dismiss(); // ✅ always dismiss
      }
    }
    
    getLanguages(): Promise<any[]> {
      return new Promise(resolve => {
        let tries = 0;
    
        const interval = setInterval(() => {
          tries++;
    
          const select = document.querySelector('.goog-te-combo') as HTMLSelectElement;
    
          if (select && select.options.length > 0) {
            clearInterval(interval);
    
            const langs = Array.from(select.options)
              .map(opt => ({
                code: opt.value,
                name: opt.text
              }))
              .filter(l => l.code);
    
            resolve(langs);
          }
    
          // ⛔ fallback after 5 seconds
          if (tries > 20) {
            clearInterval(interval);
            resolve([]); // empty list but stop loading
          }
        }, 250);
      });
    }
    
  applyLanguage(code: string) {
    const select = document.querySelector('.goog-te-combo') as HTMLSelectElement;
    if (select) {
      select.value = code;
      select.dispatchEvent(new Event('change'));
    }
  }

 
  

  filterLanguages() {
    const val = this.searchText.toLowerCase();
    this.filteredLanguages = this.languages.filter(l =>
      l.name.toLowerCase().includes(val)
    );
  }

  selectLanguage(lang: any) {
    this.modalCtrl.dismiss(lang);
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
